import { clone, path, pathOr } from 'ramda';
import {
	CLEAR_AUTH_USERS,
	CLEAR_AUTH_USER_UPDATE_ERRORS,
	CLEAR_AUTH_USER_CREATE_ERRORS,
	GET_AUTH_USER,
	GET_AUTH_USERS,
	FETCH_AUTH_USER_FAILED,
	FETCH_AUTH_USERS_FAILED,
	FETCH_AUTH_USER_SUCCEEDED,
	FETCH_AUTH_USERS_SUCCEEDED,
	UPDATE_AUTH_USER,
	UPDATE_AUTH_USER_FAILED,
	UPDATE_AUTH_USER_SUCCEEDED,
	CREATE_AUTH_USER,
	CREATE_AUTH_USER_FAILED,
	CREATE_AUTH_USER_SUCCEEDED,
} from './authUser.action';
import { authUsersInitialState } from './authUser.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const authUserReducer = (state = authUsersInitialState, action) => {
	switch (action.type) {
		case CLEAR_AUTH_USERS: {
			return {
				...state,
				...authUsersInitialState,
			};
		}

		case CLEAR_AUTH_USER_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_AUTH_USER_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_AUTH_USER:
		case GET_AUTH_USERS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_AUTH_USER_FAILED:
		case FETCH_AUTH_USERS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_AUTH_USER_SUCCEEDED: {
			const fetchedAuthUserId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingFetch: false,
			};
			if (fetchedAuthUserId) {
				newState.entities = {
					...state.entities,
					[fetchedAuthUserId]: action.payload,
				};
			}

			return newState;
		}

		case FETCH_AUTH_USERS_SUCCEEDED: {
			const newTotal = path(['payload', 'total'], action);
			const newSkip =
				newTotal >= state.skip ? { skip: action.payload && action.payload.skip + 10 } : {};
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
				totalToDisplay: newTotal,
				...newSkip,
			};
		}

		case UPDATE_AUTH_USER: {
			return createPendingState(state, 'pendingUpdate');
		}

		case UPDATE_AUTH_USER_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_AUTH_USER_SUCCEEDED: {
			const updatedAuthUserId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedAuthUserId) {
				newState.entities = {
					...state.entities,
					[updatedAuthUserId]: action.payload,
				};
			}

			return newState;
		}

		case CREATE_AUTH_USER: {
			return createPendingState(state, 'pendingCreate');
		}

		case CREATE_AUTH_USER_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case CREATE_AUTH_USER_SUCCEEDED: {
			const createdAuthUserId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingCreate: false,
			};

			if (createdAuthUserId) {
				newState.entities = {
					...state.entities,
					[createdAuthUserId]: action.payload,
				};
			}

			return newState;
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/authUsers/authUser.reducer.js